import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'employee-console',
  templateUrl: './employee-console.component.html',
  styleUrls: ['./employee-console.component.scss'],
})
export class EmployeeConsoleComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {
    this.router.navigate(['/view-board']);
  }
}
